import { Button, Drawer, Space, Avatar } from "antd";
import closeIcon from "../../../../assets/icons/x-close.svg";
import Tabs from "../../../../components/Tabs/Tabs";
import { useDispatch, useSelector } from "react-redux";
import { changeGroupDetailsTab } from "../../../../data/slices/tabsSlice";
import useWindowSize from "../../../../hooks/useWindowSize";
import { useState } from "react";
import { useEffect } from "react";
import { List } from "antd";
import { getUsers } from "../../../../data/slices/memberSlice";
import { handleQuery } from "../../../../helpers/searchQuery";

function GroupDetails({ id, open, handleClose, data, ...rest }) {
  let { width } = useWindowSize();
  const dispatch = useDispatch();
  const { groupDetailsTabs } = useSelector((state) => state.tabs);
  const { members, meta } = useSelector((state) => state.member);
  const [users, setUsers] = useState([]);
  const group = data?.group || null;

  const filterUsers = () => {
    let newUsers = [];
    for (let i = 0; i < members?.length; i++) {
      for (let k = 0; k < members[i]?.roles.length; k++) {
        if (members[i]?.roles[k].name === group?.name) {
          newUsers.push(members[i]);
        }
      }
    }
    return newUsers;
  };

  const checkState = (key, value) => {
    if (key === "State" && value === "active") {
      return "active";
    } else if (key === "State" && value === "inactive") {
      return "inactive";
    }
  };
  let groupDetails = {
    Name: group?.name || group?.name,
    Date: group?.createdAt || "--",
    State: group?.isActive ? "active" : "inactive"
  };

  const mappedObject = Object.keys(groupDetails).map((key) => (
    <div className="key_value" key={key}>
      <p className="key">{key}</p>
      <p className={`${checkState(key, groupDetails[key])}`}>{groupDetails[key]}</p>
    </div>
  ));
  useEffect(() => {
    const filteredUsers = filterUsers();
    setUsers(filteredUsers);
  }, [group, meta]);

  useEffect(() => {
    // dispatch(getUsers({ query: handleQuery({ page: 1, limit: 8 }) }));
  }, [group]);
  return (
    <Drawer
      placement="right"
      open={open}
      width={width > 1000 ? "35%" : "large"}
      closable={false}
      className="user_drawer"
    >
      <div className="head_user_drawer">
        <div className="user_avatar">
          <span>
            <p className="title">{group?.displayName}</p>
          </span>
        </div>
        <div className="close_ion" onClick={() => handleClose(id)}>
          <img src={closeIcon}></img>
        </div>
      </div>
      {/* //content drawer  */}
      <div className="user_content">
        <Tabs
          tabs={groupDetailsTabs.tabs}
          defaultTab={groupDetailsTabs.activeTab}
          setTab={changeGroupDetailsTab}
          type={groupDetailsTabs.type}
        />

        {groupDetailsTabs.activeTab === "0" ? (
          <div className="user_details">
            {mappedObject}
            <ListUsers users={users} meta={meta} />
          </div>
        ) : (
          <div className="user_settings">group settings</div>
        )}
      </div>
    </Drawer>
  );
}

export default GroupDetails;

const ListUsers = ({ users, meta }) => {
  return (
    <>
      <div className="title_list">Users</div>
      <div className="title_name_list">Name</div>
      <List
        dataSource={users}
        renderItem={(item, index) => (
          <List.Item>
            <List.Item.Meta avatar={<Avatar />} title={item.name} description={item.email} />
          </List.Item>
        )}
      />
      {/* <Pagination meta={meta} onChange={getUsers} /> */}
    </>
  );
};
